import HTMLTemplate from './template.html'
import './styles.scss'
import tippy, { followCursor } from 'tippy.js'
import 'tippy.js/dist/tippy.css'
import 'tippy.js/animations/shift-away.css'
import logoMedAireIcon from '../../resources/images/navigation/logo-medaire-icon.svg'
import logoMedAireFull from '../../resources/images/navigation/logo-medaire-full.svg'
import User from '../../modules/user'
import { ApplicationInfoModalComponent } from '../ApplicationInfo/ApplicationInfo'
import { LogoutModalComponent } from '../Logout/Logout'
import { OrganisationSettingsModal } from '../../sections/dashboard/components/OrganisationSettingsModal/OrganisationSettingsModal'
import { Settings } from '../../components/Settings/Settings'
import { Compare } from '../../components/Compare/Compare'
import { InsightsAndReports } from '../../components/InsightsAndReports/InsightsAndReports'
import { TutorialComponent } from '../Tutorial/Tutorial'
import { config } from '../../Config'
import MixPanelService from '../../services/MixPanelService'

export const SideNavigation = (() => {
    const vueComponent = {
        data() {
            return {
                isExpanded: false,
                isSecondaryMenuExpanded: false,
                medaireIcon: logoMedAireIcon,
                medaireLogo: logoMedAireFull,
                userName: '',
                userEmail: '',
                isCriticalAlert: false,
                canSeeCriticalAlerts: false,
                canSeeOrganisationSettings: false,
                canSeeExternalLinks: false,
                canSeeNewsAndEvents: true,
                canSeeComparison: true,
                canSeeInsightsAndReports: true,
                canSeeHelp: true,
                canSeeApplicationInfo: true,
                activeModule: '' // news and events, comparison, insights and reports, latest alerts
            }
        },
        created() {
            User.getLocalUserInfo().then(user => {
                this.userName = user.name
                this.userEmail = user.email
            })

            User.getUserPermissions().then(permissions => {
                if (permissions.includes('crew_locator') || permissions.includes('crew_check_automation')) {
                    this.canSeeCriticalAlerts = true
                    this.canSeeOrganisationSettings = true
                }

                if (permissions.includes('medical') && permissions.indexOf('basic') === -1) {
                    this.canSeeNewsAndEvents = false
                    this.canSeeComparison = false
                    this.canSeeInsightsAndReports = false
                }

                if (!(permissions[0] === 'basic')) {
                    this.canSeeExternalLinks = true
                }
            })

            // This function is used if the user was redirected here from the dashboard sidebar which is on a different page
            // An indicator is stored, redirected here and based on it, the respective module is shown and the indicator is removed
            function handleSessionStorageItem(key, method) {
                if (window.sessionStorage.getItem(key) !== null) {
                    method(true)
                    window.sessionStorage.removeItem(key)
                }
            }

            handleSessionStorageItem('show-comparison-module', this.showComparisonModule.bind(this))
            handleSessionStorageItem('show-insights-and-reports', this.showInsightsAndReports.bind(this))
            handleSessionStorageItem('show-latest-alerts-flyout', this.toggleLatestAlertsFlyout.bind(this))
        },
        methods: {
            showLogoutConfirmation() {
                LogoutModalComponent.$data.show = true
            },
            redirectCrewCheck() {
                MixPanelService.track('Page View - Crew Check')
                window.location.href = '/dashboard.html'
            },
            openAirQuality() {
                MixPanelService.track('Page View - Air Quality')
                window.open(config.airQualityURL, '_blank')
            },
            openCOVID19() {
                MixPanelService.track('Page View - COVID-19')
                window.open(config.covid19URL, '_blank')
            },
            openPandemicPreparedness() {
                MixPanelService.track('Page View - Pandemic Preparedness')
                window.open(config.pandemicPreparednessURL, '_blank')
            },
            showSettings() {
                MixPanelService.track('Open Settings Modal', {
                    'Clicked Location': 'Side Navigation'
                })
                Settings.showSettings = true
            },
            showHelp() {
                MixPanelService.track('Open Help Modal', {
                    'Clicked Location': 'Side Navigation'
                })
                TutorialComponent.showHelp()
            },
            showApplicationInfo() {
                MixPanelService.track('Open Application Info Modal', {
                    'Clicked Location': 'Side Navigation'
                })
                ApplicationInfoModalComponent.$data.show = true
            },
            showComparisonModule(comesFromOutside) {
                MixPanelService.track('Page View - Compare', {
                    'Clicked Location': 'Side Navigation'
                })
                if (!comesFromOutside) {
                    if (this.canSeeInsightsAndReports) {
                        InsightsAndReports.$data.showInsightsAndReports = false
                    }
                    this.hideAlertsModule()
                }
                Compare.show()
                this.activeModule = 'comparison'
                this.isExpanded = false
            },
            showInsightsAndReports(comesFromOutside) {
                MixPanelService.track('Page View - Insights And Reports')
                if (!comesFromOutside) {
                    if (this.canSeeComparison) {
                        Compare.hide()
                    }   
                    this.hideAlertsModule()
                }
                InsightsAndReports.$data.showInsightsAndReports = true
                this.activeModule = 'insights and reports'
                this.isExpanded = false
            },
            hideAlertsModule() {
                const appTemplate = document.getElementsByClassName('app-template')[0]
                if (appTemplate.classList.contains('event-panel-show')) {
                    appTemplate.classList.remove('event-panel-show')
                }
            },
            toggleLatestAlertsFlyout(comesFromOutside) {
                MixPanelService.track('Alerts panel View - Latest Alerts', {
                    'Clicked Location': 'Side Navigation'
                })
                if (!comesFromOutside) {
                    if (this.canSeeInsightsAndReports) {
                        InsightsAndReports.$data.showInsightsAndReports = false
                    }
                    if (this.canSeeComparison) {
                        Compare.hide()
                    }
                }
                const appTemplate = document.getElementsByClassName('app-template')[0]
                if (appTemplate.classList.contains('event-panel-show')) {
                    appTemplate.classList.remove('event-panel-show')
                    this.activeModule = ''
                } else {
                    appTemplate.classList.add('event-panel-show')
                    this.activeModule = 'latest alerts'
                }
                this.isExpanded = false
            },
            showOrganisationalSettings() {
                MixPanelService.track('Open Organisation Settings Modal', {
                    'Clicked Location': 'Side Navigation'
                })
                OrganisationSettingsModal.show()
            },
            goToHomeMap() {
                Compare.hide()
                this.hideAlertsModule()
                InsightsAndReports.$data.showInsightsAndReports = false
            }
        },
        template: HTMLTemplate
    }

    const DOMElement = document.getElementById('vue-side-navigation')

    if (DOMElement === null) {
        return null
    } else {
        return Vue.createApp(vueComponent).use({
            install: (app) => {
                app.directive('tooltip', {
                    beforeMount(el, binding) {
                        tippy(el, {
                            content: binding.value,
                            placement: 'bottom-start',
                            animation: 'shift-away',
                            allowHTML: true,
                            trigger: 'mouseenter',
                            touch: false,
                            arrow: false,
                            followCursor: true,
                            plugins: [followCursor]
                        })
                    }
                })
            }
        }).mount(DOMElement)
    }
})()
